import { createSelector } from 'reselect';
import { KEY } from '.';
import { GlobalState } from 'store/types';

const getDeliveryLogState = (state: GlobalState) => state[KEY];

const selectDeliveryLog = createSelector(getDeliveryLogState, (state) => state);

const selectExportData = createSelector(getDeliveryLogState, (state) => state.export.data);

const selectExportPending = createSelector(getDeliveryLogState, (state) => state.export.pending);

export const selectors = {
  selectDeliveryLog,
  selectExportData,
  selectExportPending
};
